import React, { useState, useEffect } from "react";
import {
  TextField,
  Typography,
  Box,
  AppBar,
  Toolbar,
  Button,
} from "@mui/material";
import resetPassword from "../api/user/resetPassword";

import { useTheme } from "@mui/material/styles";
import { useNavigate, useParams } from "react-router-dom";
const ResetPasswordPage = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordNotMatch, setPasswordNotMatch] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const tokenParam = useParams();
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    if (newPassword === confirmPassword) {
      setPasswordNotMatch(false);
    } else {
      setPasswordNotMatch(true);
    }
  }, [newPassword, confirmPassword]);
  const handlePasswordChanged = async () => {
    try {
      setLoading(true);
      const responseData = await resetPassword(newPassword, tokenParam.token);

      if (responseData.code === "000") {
        setSuccess(true);
      } else {
      }
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      width="100%"
      height="100vh"
      sx={{ backgroundColor: theme.palette.background.default }}
    >
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography
            alignSelf="center"
            fontSize={"h6.fontSize"}
            fontWeight={"bold"}
          >
            輸入新密碼
          </Typography>
        </Toolbar>
      </AppBar>
      {success ? (
        <Box>
          <Typography>密碼設定完成！</Typography>{" "}
          <Box display="flex" justifyContent="center" my={2}>
            <Button color="info" variant="contained" onClick={()=>{navigate("/app")}}>
              回首頁
            </Button>
          </Box>
        </Box>
      ) : (
        <Box>
          <TextField
            color="secondary"
            margin="dense"
            id="password"
            label="新密碼"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
          />
          <TextField
            color="secondary"
            margin="dense"
            id="confirmPassword"
            label="確認密碼"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={passwordNotMatch} // Here we set the error state of TextField
            helperText={passwordNotMatch ? "密碼不相同" : ""} // Here we set the helper text when there is an error
          />
          <Button
            variant="contained"
            sx={{ fontWeight: "bold", border: "1px solid #555555" }}
            color="primary"
            style={{ flexGrow: 1 }}
            onClick={handlePasswordChanged}
            disabled={loading}
          >
            {"送出"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ResetPasswordPage;
